import { CustomTheme } from "./interface";

export const fontWeight: CustomTheme["other"]["fontWeights"] = {
  extraBold: 800,
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
  light: 300,
};
